import { render, staticRenderFns } from "./DenyMemberModal.vue?vue&type=template&id=3221255c"
import script from "./DenyMemberModal.vue?vue&type=script&lang=js"
export * from "./DenyMemberModal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports